export class HttpError {
	message:string;
	key:string;
	data:string[];
	dontShow:boolean = false;

	constructor(data:any){
		this.message = data.message;
		this.key = data.key;
		this.data = data.data;
	}

	getMessage(){
		if (this.key == "TOKEN_EXPIRED"){
			return "Your session has expired. Please login again";
		}
		return this.message;
	}
}